import { useRef, useState } from 'react';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, useBreakpoint } from '@gn-audio/jss-components';

import { JabraSlide, JabraSlider, JabraSliderRef } from 'common/components/JabraSlider/JabraSlider';
import { PillsSliderNavigation } from 'common/components/JabraSlider/PillsSliderNavigation';
import { TopBannerFields, TopBannerItem } from 'composables/Product/TopBanner/TopBannerItem';

type TopBannerSliderProps = ComponentProps & {
  fields: {
    Banners: (TopBannerFields & { id: string })[];
  };
};

const TopBannerSlider = ({ fields }: TopBannerSliderProps) => {
  const banners = fields?.Banners || [];
  const sliderRef = useRef<JabraSliderRef>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const { isBelowMd } = useBreakpoint('md', true);

  if (!banners.length || banners.length <= 1) {
    return null;
  }

  const handleGoTo = (index: number) => {
    sliderRef.current?.goTo(index);
  };

  return (
    <div className="relative">
      <JabraSlider
        ref={sliderRef}
        showSlideArrows={false}
        slideClassName="basis-full"
        className="overflow-x-hidden"
        onChange={setActiveIndex}
      >
        {banners.map((banner) => (
          <JabraSlide key={banner.id}>
            <TopBannerItem fields={banner} />
          </JabraSlide>
        ))}
      </JabraSlider>
      <PillsSliderNavigation
        activeIndex={activeIndex}
        total={banners.length}
        buttonVariant="primary"
        sliderButtonPosition={isBelowMd ? 'center' : 'start'}
        goTo={handleGoTo}
        className="absolute bottom-[1rem] right-[1rem] md:bottom-[2rem] md:right-[2.5rem]"
      />
    </div>
  );
};

export default withDatasourceCheck()<TopBannerSliderProps>(TopBannerSlider);
